import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SimulationService } from '../../services/alert.service';
import { SimulationApiService } from '../../services/simulation-api.service';
import { VeiculoSimulationDTO } from '../../dtos/veiculo-simulation.dto';
import { ImovelSimulationDTO } from '../../dtos/imovel-simulation.dto';
import { getWhatsAppUrl } from '../../config/whatsapp.config';

declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  isProcessing: boolean = false;

  constructor(
    private simulationService: SimulationService,
    private apiService: SimulationApiService,
    private router: Router
  ) { }

  isMenuOpen: boolean = false;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    document.body.style.overflow = '';
  }

  isVeiculosPage(): boolean {
    return this.router.url === '/veiculos' || this.router.url === '/';
  }

  isImoveisPage(): boolean {
    return this.router.url === '/imoveis';
  }

  isLegalPage(): boolean {
    return this.router.url === '/politica-de-privacidade' || this.router.url === '/termos-de-uso';
  }

  getCurrentPageName(): string {
    if (this.router.url === '/politica-de-privacidade') {
      return 'Política de Privacidade';
    } else if (this.router.url === '/termos-de-uso') {
      return 'Termos de Uso';
    } else if (this.isVeiculosPage()) {
      return 'Consórcio de Veículos';
    } else if (this.isImoveisPage()) {
      return 'Consórcio de Imóveis';
    }
    return 'Home';
  }

  onWhatsAppClick(): void {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'whatsapp_click',
        'category': 'contact',
        'label': 'navbar_button'
      });
    }

    window.open(getWhatsAppUrl(), '_blank');
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  onSimulate() {
    const isImoveis = this.router.url.includes('imoveis');

    const beforeConfirm = async (formData: any) => {
      if (isImoveis) {
        const data: ImovelSimulationDTO = {
          name: formData.name,
          email: formData.email,
          telefone: formData.phone,
          valor: 'Não informado',
          tipoConsorcio: 'Imoveis'
        };
        return new Promise((resolve, reject) => {
          this.apiService.sendImovelSimulation(data).subscribe({
            next: () => resolve(true),
            error: (err) => reject(err)
          });
        });
      } else {
        const data: VeiculoSimulationDTO = {
          name: formData.name,
          email: formData.email,
          telefone: formData.phone,
          valor: 'Não informado',
          tipoConsorcio: 'Veiculos'
        };
        return new Promise((resolve, reject) => {
          this.apiService.sendVeiculoSimulation(data).subscribe({
            next: () => resolve(true),
            error: (err) => reject(err)
          });
        });
      }
    };

    this.simulationService.openSimulationModal('Faça sua Simulação', undefined, beforeConfirm).then(result => {
      if (result.isConfirmed) {
        this.simulationService.showSuccessAlert();
      }
    });
  }
}
